import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@one-thd/sui-atomic-components';
import { RelatedSearchPill } from './RelatedSearchPill';

const RelatedSearchLinks = ({ relatedLinks, title = 'Related Searches' }) => {
  return (
    <div className="sui-w-full sui-flex sui-flex-col sui-gap-4">
      <Typography variant="h2" weight="display">{title}</Typography>
      {/* eslint-disable-next-line tailwindcss/no-arbitrary-value */}
      <div className="sui-flex sui-flex-row sui-flex-wrap sui-leading-tight sui-gap-4 [&_a:hover]:sui-no-underline">
        {relatedLinks.map((relatedSearchResult, index) => {
          const copyText = relatedSearchResult.anchor || relatedSearchResult.keyword;
          return (
            <RelatedSearchPill
              key={`relatedSearchResult-${copyText}${index}`}
              relatedSearchResult={relatedSearchResult}
              index={index}
              copyText={copyText}
            />
          );
        })}
      </div>
    </div>
  );
};

export { RelatedSearchLinks };

RelatedSearchLinks.propTypes = {
  relatedLinks: PropTypes.arrayOf(
    PropTypes.shape({
      anchor: PropTypes.string,
      url: PropTypes.string
    })
  ).isRequired,
  title: PropTypes.string
};
